import { render, staticRenderFns } from "./PelletizingEquipParaList.vue?vue&type=template&id=f1ddd7c6&"
import script from "./PelletizingEquipParaList.vue?vue&type=script&lang=js&"
export * from "./PelletizingEquipParaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports